<template>
	<div
		class="elfsight-app-eadfcfbf-c994-4675-9a43-b3adb58f88a9"
		data-elfsight-app-lazy
	/>
</template>

<script setup>
onMounted(() => {
	useElfsight()
})
</script>
